import { IDistributorMigration } from "../pages/MigrationQueue"
import endpoints from "../utils/endpoints"
import { Api } from "./api"
import { notificationError, notificationSucces } from "./notification"

export async function getMigrationQueueItems() {
  let res: IDistributorMigration[] = []

  await Api.get(endpoints.getMigrationQueueItems).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data.distributors
      }
    } else {
      notificationError('Could not get migration queue items')
    }
  }).catch((err: string) => {
    notificationError('Could not get migration queue items')
  })

  return res
}

export async function saveMigrationQueueItems(payload: any) {
  let res = false
  await Api.post(endpoints.saveMigrationQueueItems, payload).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Migration queue items saved')
        res = true
      }
    } else {
      notificationError('Could not save migration queue items')
    }
  }).catch((err: string) => {
    notificationError('Could not save migration queue items')
  })
  return res
}